<template>
  <v-card class="p-5 registerDriver" :loading="loading.register">
    <h5>Cadastre-se</h5>
    <v-form ref="formRegister">
      <v-row>
        <v-col cols="12" sm="12">
          <v-text-field
              v-model="register.name"
              autocomplete="new-password"
              :rules="rules.name"
              @keyup.enter="validateRegister()"
              label="Nome Completo">
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              autocomplete="new-password"
              v-model="register.document"
              :rules="rules.document"
              @keyup.enter="validateRegister()"
              label="CPF/CNPJ">
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              v-mask="['(##) ####-####', '(##) #####-####']"
              autocomplete="new-password"
              v-model="register.phone"
              :rules="rules.phone"
              @keyup.enter="validateRegister()"
              label="Celular">
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              v-model="register.birth_date"
              label="Data de nascimento"
              v-mask="'##/##/####'"
              :rules="rules.birth_date"
              hint="dd/mm/aaaa"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-text-field
              :rules="rules.email"
              autocomplete="new-password"
              v-model="register.email"
              @keyup.enter="validateRegister()"
              label="E-mail">
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              v-model="register.cep"
              label="CEP"
              v-mask="'#####-###'"
              :rules="rules.cep"
              @blur="searchCep"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              v-model="register.address"
              label="Endereço"
              :rules="rules.address"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
              v-model="register.number"
              :rules="rules.number"
              required
              v-mask="['#####']"
              label="Nº"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
              v-model="register.complement"
              label="Complemento"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
              v-model="register.district"
              :rules="rules.district"
              required
              label="Bairro"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
              v-model="register.city"
              :rules="rules.city"
              required
              label="Cidade"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
              v-model="register.uf"
              :rules="rules.uf"
              required
              @keyup="register.uf = register.uf.toUpperCase()"
              v-mask="['SS']"
              label="Estado"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              type="password"
              autocomplete="new-password"
              :rules="rules.password"
              v-model="register.password"
              @keyup.enter="validateRegister()"
              label="Senha">
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              type="password"
              autocomplete="new-password"
              :rules="rules.confirm_password"
              v-model="register.confirm_password"
              @keyup.enter="validateRegister()"
              label="Confirmar Senha">
          </v-text-field>
        </v-col>
      </v-row>
      <v-checkbox v-model="register.verification"
                  color="blue darken-1"
                  :rules="rules.verification">
        <template v-slot:label>
          <div class="pt-3 w-100">
            Eu concordo com os&nbsp;
            <a href="#" @click.prevent="modal.term = true, register.verification = false"> Termos de Uso</a>
          </div>
          <v-dialog v-model="modal.term" width="80%">
            <v-card>
              <v-card-title>
                <h5>Termos de Uso</h5>
                <i class="fas fa-window-close ml-auto icon-close-modal" @click.prevent="modal.term = false"></i>
              </v-card-title>
              <v-card-text>
                <terms-conditions type="termos_de_uso"></terms-conditions>
                <div class="row">
                  <button class="btn-blue mx-auto mt-5"
                          @click.prevent="modal.term = false,  register.verification = true">Aceitar
                  </button>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>
      </v-checkbox>
      <v-alert type="error" color="#e72c1f" v-if="errorRegister !== null">
        {{ errorRegister }}
      </v-alert>
      <v-btn color="#000" :loading="loading.register"
             :disabled="loading.register"
             @click.prevent="validateRegister()"
             class="btn-blue ml-auto mt-3">
        Cadastrar
      </v-btn>
    </v-form>
    <v-dialog class="confirmRegister" v-model="modal.register" width="80%">
      <v-card>
        <v-card-title>
          <h5>Confirme o seu cadastro</h5>
          <i class="fas fa-window-close ml-auto icon-close-modal" @click.prevent="modal.register = false"></i>
        </v-card-title>
        <v-card-text>
          <v-alert type="success">
            Uma mensagem de confirmação foi enviada para:
          </v-alert>
          <div class="d-block d-md-flex justify-content-around text-center">
            <div class="col-12 col-md-6"
                 v-if="register.email !== null && register.email !== undefined && register.email !== ''">
              <i class="fas fa-envelope-open-text d-block" style="font-size: 30px; margin-bottom: 10px;"></i>
              <span class="bold-text">{{ register.email }}</span>
            </div>
            <div class="col-12 col-md-6"
                 v-if="register.phone !== null && register.phone !== undefined && register.phone !== ''">
              <i class="fas fa-mobile-alt d-block" style="font-size: 30px; margin-bottom: 10px;"></i>
              <span class="bold-text">{{ register.phone }}</span>
            </div>
          </div>
          <div class="row">
            <button class="btn-blue mx-auto mt-5" @click.prevent="refreshPage()">Acessar</button>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import TermsConditions from './TermsConditions'

export default {
  name: "register",
  components: {TermsConditions},
  data: function () {
    return {
      errorRegister: null,
      showBirthDatePicker: false,
      dateFormatted: '',
      register: {
        name: '',
        email: '',
        phone: '',
        password: '',
        confirm_password: '',
        document: '',
        verification: false,
        birth_date: '',
        cep: '',
        address: '',
        number: '',
        complement: '',
        district: '',
        city: '',
        uf: '',
      },
      modal: {
        term: false,
        notifications: false,
        register: false
      },
      loading: {
        register: false
      },
      rules: {
        name: [
          value => (value || '').length > 0 || 'O campo nome é obrigatório',
          value => this.validName(value) || 'Digite o seu nome completo'
        ],
        document: [
          value => (value || '').length > 0 || 'O campo CPF/CNPJ é obrigatório',
          value => {
            return this.validateIdentification(value) || 'Digite um CPF/CNPJ válido'
          },
        ],
        phone: [
          value => !!value || 'O campo celular é obrigatório',
          value => value.replace(/\D+/g, '').length === 11 || 'O celular deve conter 11 dígitos (incluindo o DDD)',
          value => /^(?:(55\d{2})|\d{2})[6-9]\d{8}$/.test(value.replace(/\D+/g, '')) || 'Digite um número válido com DDD + 9 dígitos',
        ],
        email: [
          value => (value.length > 0 || this.register.phone.length > 0) || 'O campo e-mail é obrigatório',
          value => (this.validEmail(value) || (value === '' && this.register.phone.length > 0)) || 'Digite um e-mail válido',
        ],
        password: [
          value => (value || '').length > 0 || 'O campo senha é obrigatório',
          value => (value || '').length >= 6 || 'A senha deve conter pelo menos 6 caracteres',
        ],
        confirm_password: [
          value => (value || '').length > 0 || 'O campo confirmar senha é obrigatório',
          value => (value === this.register.password) || 'O campo de confirmação de senha esta diferente',
        ],
        verification: [
          value => value === true || 'Você deve aceitar os Termos de Uso para continuar',
        ],
        birth_date: [
          v => !!v || 'A data de nascimento é obrigatória',
          v => /^\d{2}\/\d{2}\/\d{4}$/.test(v) || 'Data inválida (dd/mm/aaaa)'
        ],
        cep: [
          v => !!v || 'O CEP é obrigatório',
          v => /^[0-9]{5}-[0-9]{3}$/.test(v) || 'CEP inválido'
        ],
        address: [
          v => !!v || 'O endereço é obrigatório'
        ],
        number: [value => (value || '').length > 0 || 'O campo número é obrigatório',],
        district: [value => (value || '').length > 0 || 'O campo bairro é obrigatório',],
        city: [value => (value || '').length > 0 || 'O campo cidade é obrigatório',],
        uf: [value => (value || '').length > 1 || 'O campo estado é obrigatório',],
      },
    }
  },
  methods: {
    formatDate(value) {
      if (value) {
        const parts = value.split('-');
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return '';
    },
    searchCep: function () {
      if (this.register.cep && this.register.cep.length === 9) {
        this.$viaCep.buscarCep(this.register.cep).then((obj) => {
          this.register.address = obj.logradouro;
          this.register.city = obj.localidade;
          this.register.district = obj.bairro;
          this.register.uf = obj.uf;
        });
      }
    },
    refreshPage: function () {
      this.modal.register = false;
      this.$emit('scrollToLogin', true);
    },
    async validateRegister() {
      if (!this.$refs.formRegister.validate()) {
        this.loading.register = false;
        return;
      }

      const params = new URLSearchParams();
      if (this.register.document) {
        params.append('identification', this.register.document.replace(/[().\s\-\/]/g, ''));
      }
      if (this.register.email) {
        params.append('email', this.register.email);
      }
      if (this.register.phone) {
        params.append('phone', this.register.phone.replace(/[().\s\-\/]/g, ''));
      }

      try {
        await axios.get(`api/common/user/validate?${params.toString()}`);
        this.registerDriver();
      } catch (error) {
        this.loading.register = false;
        if (error.response && error.response.data && error.response.data.errors) {
          if (error.response.data.errors.identification) {
            this.errorRegister = 'O CPF/CNPJ informado já está em uso.';
          }
          if (error.response.data.errors.phone) {
            this.errorRegister = 'O telefone informado já está em uso.';
          }
        } else {
          this.errorRegister = error.response.data.message;
        }
      }
    },
    cleanPhoneMask: function (input) {
      return input.replace(/[().\s\-\/]/g, '');
    },
    getAddressObj() {
      return {
        address: this.register.address,
        cep: this.register.cep,
        city: this.register.city,
        complement: this.register.complement,
        district: this.register.district,
        number: this.register.number,
        uf: this.register.uf,
      }
    },
    parseDate(date) {
      const parts = date.split('/');
      return parts.length === 3 ? `${parts[2]}-${parts[1]}-${parts[0]}` : null;
    },
    formatAddressToStore(addressToFormat) {
      let address = `${addressToFormat.address},${addressToFormat.number}`
      if (addressToFormat.complement) {
        address += `,${addressToFormat.complement}`
      }
      return {
        address,
        district: addressToFormat.district,
        city: addressToFormat.city,
        uf: addressToFormat.uf,
        cep: addressToFormat.cep.replace(/[^0-9]/g, ''),
      }
    },
    registerDriver: function () {
      const driver = {
        name: this.register.name,
        identification: this.register.document.split('.').join('').split('-').join('').split('/').join(''),
        phone: this.cleanPhoneMask(this.register.phone) || null,
        email: this.register.email || null,
        password: this.register.password,
        password_confirmation: this.register.confirm_password,
        cep: this.register.cep,
        address: this.formatAddressToStore(this.getAddressObj()),
        number: this.register.number,
        complement: this.register.complement,
        district: this.register.district,
        city: this.register.city,
        uf: this.register.uf,
        birth_date: this.parseDate(this.register.birth_date)
      };
      if (driver.phone === null) {
        delete driver.phone;
      } else {
        driver.phone = driver.phone.split('(').join('').split(')').join('').split(' ').join('').split('-').join('');
      }
      if (driver.email === null) {
        delete driver.email;
      }

      this.errorRegister = null;
      axios
          .post('/api/signup', driver)
          .then(response => {
            if (response.data.id) {
              this.modal.register = true;
            }
            localStorage.setItem('token', response.data.access_token);
            axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('token');
            axios.get('/api/user').then(res => {
              localStorage.setItem('user', JSON.stringify({
                id: res.data.id,
                driver_id: res.data.driver_id,
                identification: res.data.identification,
                name: res.data.name,
              }));
              location.reload();
            });
          })
          .catch(error => {
            if (error.response.data.error.errors) {
              if (error.response.data.error.errors.identification) {
                this.errorRegister = 'O CPF/CNPJ informado já está cadastrado.'
              }
              if (error.response.data.error.errors.phone) {
                this.errorRegister = 'O celular informado já está cadastrado.'
              }
              if (error.response.data.error.errors.email) {
                this.errorRegister = 'O e-mail informado já está cadastrado.'
              }
            } else {
              this.errorRegister = error.response.data.error.message;
            }
          })
          .finally(() => {
            this.loading.register = false;
          });
    },
    validName: function (value) {
      const pattern = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;
      const split = value.split(' ');
      return value.includes(' ') && value.length > 6 && split[1].length > 1 && pattern.test(value)
    },
    validEmail: function (value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value)
    },
    validateIdentification: function (value) {
      if (!value) return false;

      const cleanNumber = value.replace(/\D/g, '');

      if (cleanNumber.length === 11) {
        return this.validateCPF(cleanNumber);
      } else if (cleanNumber.length === 14) {
        return this.validateCNPJ(cleanNumber);
      }

      return false;
    },
    validateCPF(cpf) {
      if (/^(\d)\1{10}$/.test(cpf)) return false;

      let sum = 0;
      let remainder;

      for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      }

      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cpf.substring(9, 10))) return false;

      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      }

      remainder = (sum * 10) % 11;
      if (remainder === 10 || remainder === 11) remainder = 0;
      if (remainder !== parseInt(cpf.substring(10, 11))) return false;

      return true;
    },
    validateCNPJ(cnpj) {
      if (/^(\d)\1{13}$/.test(cnpj)) return false;

      const weights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseInt(cnpj.charAt(i)) * weights[i + 1];
      }

      let remainder = sum % 11;
      const firstDigit = remainder < 2 ? 0 : 11 - remainder;
      if (parseInt(cnpj.charAt(12)) !== firstDigit) return false;

      sum = 0;
      for (let i = 0; i < 13; i++) {
        sum += parseInt(cnpj.charAt(i)) * weights[i];
      }

      remainder = sum % 11;
      const secondDigit = remainder < 2 ? 0 : 11 - remainder;
      if (parseInt(cnpj.charAt(13)) !== secondDigit) return false;

      return true;
    },

  },
}
</script>

<style scoped>
h5 {
  font-family: Roboto-Black !important;
  font-size: 24px !important;
  color: #58595B !important;
}

.btn-blue {
  text-transform: capitalize !important;
  background: #000 !important;
  color: #ffffff !important;
  font-family: Roboto-Black !important;
  width: 120px;
  height: 43px !important;
  border-radius: 4px !important;
  padding: 8px 15px !important;
  border: 3px solid #000 !important;
}

.btn-blue:hover {
  background: transparent !important;
  color: #000 !important;
}

.theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: red !important;
}

.v-text-field__slot input {
  color: red
}

a {
  color: #000;
  font-family: Roboto-Bold, serif;
  font-size: 14px;
}

.registerDriver {
  width: 600px;
}

@media only screen and (max-width: 1024px) {
  .registerDriver {
    margin: 0 auto;
  }
}

@media only screen and (max-width: 500px) {
  .registerDriver {
    text-align: center;
    padding: 20px !important;
  }

  .btn-blue {
    width: 100%;
  }
}

</style>
